import { useEffect, useState } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { getSchoolInfo } from "../../actions/SchoolActions";
import { awaitableRootSchoolCode } from "../../apis/ApiConfig";

interface FooterProps {
    auth: any | undefined,
    school: any | undefined,
    getSchoolInfo: any | undefined
}

const Footer: React.FC<FooterProps> = ({ auth, school, getSchoolInfo }) => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let run = async () => {
            if (!school?.school || Object.keys(school.school).length === 0) {
                let schoolCode: string = await awaitableRootSchoolCode();
                getSchoolInfo(schoolCode);
            }
        }
        run();
    }, [school, getSchoolInfo])

    const renderSchoolInfo = () => {
        if (school.school && Object.keys(school.school).length > 0) {
            return (
                <>
                    <Col className="pt-2">
                        <a href={`https://${school.school.schoolUrl}`} target="_blank" rel="noopener noreferrer" >{school.school.name}</a>
                    </Col>
                    <Col className="pt-2">
                        <a href="https://www.inceptia.org/student-landing/verification-gateway-students" target="_blank" rel="noopener noreferrer" >Inceptia Verification Gateway</a>
                    </Col>
                    <Col md={3} className="pt-2 border-left border-right">
                        {auth.isSignedIn ? (<>Phone: 1-833-932-1877</>) : (<>Phone: 1-877-395-1050</>)} | Email: <a href="mailto:vgcs@verificationgateway.org">vgcs@verificationgateway.org</a>
                    </Col>
                </>
            );
        } else {
            return null;
        }
    }

    return (
        <div id="footer" className="sticky-bottom">
            <Row>
                {renderSchoolInfo()}
                <Col>
                    <button className="btn btn-link" onClick={() => setShowModal(true)} >Accessibility</button>
                </Col>
                <Col className="pt-2">
                    <a href="https://www.inceptia.org/privacy/" target="_blank" rel="noopener noreferrer" >Privacy</a>
                </Col>
            </Row>
            <div className="inline">
                <p><small><i className="far fa-copyright" /></small> {new Date().getFullYear()} Inceptia</p>
            </div>
            <Modal size='lg' show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Body>
                    <p>
                        Inceptia strives to make all of the organization's English web-based services accessible for people with disabilities by
                        following Web Content Accessibility Guidelines (WCAG 2.0) Level AA. If you encounter an issue with accessibility, please
                        contact Inceptia at <a href="mailto: inceptiacs@inceptia.org">inceptiacs@inceptia.org</a>. We will review the issue and respond to your concern within 60 days.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

const mapStateToProps = (state: FooterProps) => {
    return {
        school: state.school,
        auth: state.auth
    };
};

export default connect(mapStateToProps, { getSchoolInfo })(Footer);
